module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAAXNSR0IArs4c6QAAACpQTFRFAAAAIGDvK2ntLGjtK2jsK2nsLGnsLGjsLGnrKmfrK2nrK2jrLGnsLGnsHhu4JwAAAA10Uk5TABBwf5Cgr7/Az8/Q787SQ8cAAABlSURBVBjTY2AAAY4CBgTgvUBvDqMhiCMsAGS2MDDdEuC9wLhWgcGN4QYDQ+xC3gtSVxkYekEc1luyF9cGQDkMsWtvASWgHNa7dwPgHIZYkASMwzkBiQMBRHPulMPBWYa9d+HgNgCJtjdzhTC7cQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/down-cailiao.png
// module id = K78C
// module chunks = 0